const ROLES = {
  HOST: 'host',
  PARTICIPANT: 'participant',
}

export {
  ROLES,
}
